export default __webpack_public_path__ + "static/media/loan-application.8357a76c.md";